import '.ai{padding-block:0.5rem;}.ssr-plugin'
import '.da{border-radius:0.5rem;}.ssr-plugin'
import '.b9{border:none;}.ssr-plugin'
import '.ap{cursor:pointer;}.ssr-plugin'
import '.cd{user-select:none;}.ssr-plugin'
import Row from '@app/components/layout/Row'
import { Style, styled } from 'inlines'
import { Text } from '../typography/Text'

export type ToggleOption<T> = {
  label: string
  value: T
  style?: Style
}

export type ToggleProps<T> = {
  options: ToggleOption<T>[]
  selectedOption: T
  setSelectedOption: (option: T) => void
}

export const Toggle = <T extends string>({
  options,
  selectedOption,
  setSelectedOption,
}: ToggleProps<T>) => {
  return (
    <Row
      alignItems="center"
      gap={'0.5rem'}
      style={{
        padding: '0.25rem',
        background: 'var(--shades-blue-50)',
        borderRadius: '0.75rem',
        cursor: 'pointer',
      }}
    >
      {options.map((option, i) => (
        <styled.button className="ai da b9 ap cd"
          key={i}
          onClick={() => setSelectedOption(option.value)}
          style={{
            backgroundColor:
              selectedOption === option.value
                ? 'var(--shades-white)'
                : 'transparent',
            boxShadow:
              selectedOption === option.value
                ? '0 3px 10px 0 rgba(0, 0, 0, 0.05)'
                : 'none',
            ...option.style,
          }}
        >
          <Text.Medium
            color={
              selectedOption === option.value
                ? 'var(--primary-blue)'
                : 'var(--shades-blue-400)'
            }
          >
            {option.label}
          </Text.Medium>
        </styled.button>
      ))}
    </Row>
  )
}
